import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';
import AllRoutes from '../nametitle/AllRoutes';
import { LoadAllContact } from '../actions/ActivitesPages/ManagerPageAction';
import { getDataFromFile } from '../actions/SearchAction';
import { Localvalue } from '../nametitle/localValue';
import { changeLanguage, valueLangSelect } from '../nametitle/translateFunction';

const Navbar = () => {
    const bg = `logo_plenitude.png`;


    const [id, setid] = useState();

    const [coverPicture, setcoverPicture] = useState();
    const [logo, setlogo] = useState();
    const [name, setname] = useState();
    const [email, setemail] = useState();
    const [telephone1, settelephone1] = useState();
    const [telephone2, settelephone2] = useState();
    const [telephone3, settelephone3] = useState();

    const [facebook, setfacebook] = useState();
    const [youtube, setyoutube] = useState();
    const [instagram, setinstagram] = useState();



    const [Loading, setLoading] = useState();

    useEffect(() => {


        const savedLang = sessionStorage.getItem(valueLangSelect) || 'fr'; // Langue par défaut : français
        changeLanguage(savedLang); // Appliquer la langue au chargement


        const object = getDataFromFile(Localvalue.activitePageData);
        setlogo(object && object.contact && object.contact.activite1 && object.contact.activite1.logo ? object.contact.activite1.logo : "");
        setname(object && object.contact && object.contact.activite1 && object.contact.activite1.name ? object.contact.activite1.name : "");
        setcoverPicture(object && object.contact && object.contact.activite1 && object.contact.activite1.coverPicture ? object.contact.activite1.coverPicture : "");
        // ***************************************************     Activté 3
        setemail(object && object.contact && object.contact.activite2 && object.contact.activite2.email ? object.contact.activite2.email : "");
        settelephone1(object && object.contact && object.contact.activite2 && object.contact.activite2.telephone1 ? object.contact.activite2.telephone1 : "");
        settelephone2(object && object.contact && object.contact.activite2 && object.contact.activite2.telephone2 ? object.contact.activite2.telephone2 : "");
        settelephone3(object && object.contact && object.contact.activite2 && object.contact.activite2.telephone3 ? object.contact.activite2.telephone3 : "");
        // ***************************************************     Activté 3
        setfacebook(object && object.contact && object.contact.activite3 && object.contact.activite3.facebook ? object.contact.activite3.facebook : "");
        setyoutube(object && object.contact && object.contact.activite3 && object.contact.activite3.youtube ? object.contact.activite3.youtube : "");
        setinstagram(object && object.contact && object.contact.activite3 && object.contact.activite3.instagram ? object.contact.activite3.instagram : "");
        LoadAllContact(setid, setlogo, setname, setcoverPicture,
            setemail, settelephone1, settelephone2, settelephone3,
            setfacebook, setyoutube, setinstagram)
    }, []);


    const location = useLocation();


















    return (
        <div>
            <div className=" container-fluid border-bottom d-none d-lg-block">
                <div className=" row gx-0">
                    <div className=" col-lg-4 text-center py-2">
                        <div className=" d-inline-flex align-items-center">
                            <i className=" bi bi-geo-alt fs-1 text-primary me-3"></i>
                            <div className=" text-start">
                                <h6 className=" text-uppercase mb-1"><span className="translatable">nous Sommes situé ?</span></h6>
                                <span className="translatable">Cote d{"'"}Ivoire , Abidjan  , Deux plateaux , Carefour Marché</span>
                            </div>
                        </div>
                    </div>
                    <div className=" col-lg-4 text-center border-start border-end py-2">
                        <div className=" d-inline-flex align-items-center">
                            <i className=" bi bi-envelope-open fs-1 text-primary me-3"></i>
                            <div className=" text-start">
                                <h6 className="translatable text-uppercase mb-1">email</h6>
                                <span>{email}</span>
                            </div>
                        </div>
                    </div>
                    <div className=" col-lg-4 text-center py-2">
                        <div className=" d-inline-flex align-items-center">
                            <i className=" bi bi-phone-vibrate fs-1 text-primary me-3"></i>
                            {
                                telephone1 == "" ?
                                    <div className=" bg-gray-200 rounded-lg w-full h-7 "></div> :
                                    <div className=" text-start">
                                        <h6 className="translatable text-uppercase mb-1">Appellez nous</h6>
                                        <div className=" flex flex-col space-y-3 flex-wrap space-x-2">
                                            <span>+{telephone1}</span>
                                            <span>+{telephone2}</span>
                                            <span>+{telephone3}</span>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <nav className=" navbar navbar-expand-lg bg-white navbar-light shadow-sm py-3 py-lg-0 px-3 px-lg-0">
                <a href={`/`} className=" navbar-brand ms-lg-5">
                    <h1 className=" m-0 text-uppercase text-dark"><img src={`${bg}`} className=" h-[50px] w-[50px] rounded-[50px]" /></h1>
                </a>
                <button className=" navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span className=" navbar-toggler-icon"></span>
                </button>
                <div className=" visible navbar-collapse collapse" id="navbarCollapse">
                    <div className=" navbar-nav ms-auto py-0">

                        <a href={`/`} class={`nav-item nav-link ${location.pathname === "/" ? "active" : ""} text-gray-800 translatable`}>Accueil</a>
                        <a href={`/${AllRoutes.temoignage}`} class={`nav-item nav-link ${location.pathname === "/" + AllRoutes.temoignage ? "active" : ""} text-gray-800 translatable`}>Témoignages</a>
                        <a href={`/${AllRoutes.ecole}`} class={`nav-item nav-link ${location.pathname === "/" + AllRoutes.ecole ? "active" : ""} text-gray-800 translatable`}>Enseignements</a>
                        {/*<a href={`/${AllRoutes.bible}`} className="translatable nav-item nav-link text-gray-800">Lecture</a> */}
                        <a href={`/${AllRoutes.about}`} class={`nav-item nav-link ${location.pathname === "/" + AllRoutes.about ? "active" : ""} text-gray-800 translatable`}>A propos </a>
                        <a href={`/${AllRoutes.donationckeckout}`} class={`nav-item nav-link ${location.pathname === "/" + AllRoutes.donationckeckout ? "active" : ""} text-gray-800 translatable`}>Faire un don </a>
                        <a href={`/${AllRoutes.contact}`} class={`nav-item nav-link ${location.pathname === "/" + AllRoutes.contact ? "active" : ""} text-gray-800 translatable`}>Contact</a>

                        {
                            /*
                            
                            <div className="translatable nav-item dropdown">
                            <a href="#" className="translatable nav-link dropdown-toggle" data-bs-toggle="dropdown">Activités</a>
                            <div className="translatable dropdown-menu m-0">
                                <a href={`/${AllRoutes.evenement}`} className=" dropdown-item text-gray-800">Evènement</a>
                                <a href={`/${AllRoutes.dons}`} className=" dropdown-item text-gray-800">Dons</a>
                                <a href={`/${AllRoutes.ecole}`} className=" dropdown-item text-gray-800">Ecole Biblique</a>
                            </div>
                            </div>
                            */
                        }




                        <div className=" nav-item dropdown">
                            <a href="#" className=" nav-link dropdown-toggle" style={{ display: "flex", justifyContent: "space-between" }} data-bs-toggle="dropdown"><span className="pr-4 translatable">Traduction</span>
                                <img id="frFlag" src="img/fr.jpg"
                                    style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible", display: "none" }} />
                                <img id="enFlag" src="img/en.jpg') }}"
                                    style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "hidden", display: "none" }} />
                                <img id="esFlag" src="img/es.jpg"
                                    style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "hidden", display: "none" }} />
                                <img id="deFlag" src="img/de.jpg"
                                    style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "hidden", display: "none" }} />
                                <img id="arFlag" src="img/ar.jpg"
                                    style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "hidden", display: "none" }} />
                                <img id="zhFlag" src="img/zh.jpg"
                                    style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "hidden", display: "none" }} />
                                <img id="jaFlag" src="img/ja.jpg"
                                    style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "hidden", display: "none" }} />
                                <img id="ptFlag" src="img/pt.jpg"
                                    style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "hidden", display: "none" }} />
                                <img id="itFlag" src="img/it.jpg"
                                    style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "hidden", display: "none" }} />
                            </a>
                            <div className=" dropdown-menu m-0 ">
                                {/*Listes des langues */}
                                <li style={{ width: "100%" }} className="border-b py-2"><a className=" dropdown-item" style={{ display: "flex", justifyContent: "space-between" }} href="#fr" onClick={()=>changeLanguage('fr')}>
                                    <span>
                                        <img src="img/fr.jpg"
                                            style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible" }} />
                                    </span>
                                    <span>Français</span></a></li>
                                <li style={{ width: "100%" }} className="border-b py-2"><a className=" dropdown-item" style={{ display: "flex", justifyContent: "space-between" }} href="#en" onClick={()=>changeLanguage('en')}>
                                    <span>
                                        <img src="img/en.jpg"
                                            style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible" }} />
                                    </span>
                                    English</a></li>
                                <li style={{ width: "100%" }} className="border-b py-2"><a className=" dropdown-item" style={{ display: "flex", justifyContent: "space-between" }} href="#es" onClick={()=>changeLanguage('es')}>
                                    <span>
                                        <img src="img/es.jpg"
                                            style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible" }} />
                                    </span>
                                    Español</a></li>
                                <li style={{ width: "100%" }} className="border-b py-2"><a className=" dropdown-item" style={{ display: "flex", justifyContent: "space-between" }} href="#de" onClick={()=>changeLanguage('de')}>
                                    <span>
                                        <img src="img/de.jpg"
                                            style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible" }} />
                                    </span>
                                    Deutsch</a></li>
                                <li style={{ width: "100%" }} className="border-b py-2"><a className=" dropdown-item" style={{ display: "flex", justifyContent: "space-between" }} href="#ar" onClick={()=>changeLanguage('ar')}>
                                    <span>
                                        <img id="frFlag" src="img/ar.jpg"
                                            style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible" }} />
                                    </span>
                                    العربية</a></li>
                                <li style={{ width: "100%" }} className="border-b py-2"><a className=" dropdown-item" style={{ display: "flex", justifyContent: "space-between" }} href="#zh" onClick={()=>changeLanguage('zh')}>
                                    <span>
                                        <img src="img/zh.jpg"
                                            style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible" }} />
                                    </span>
                                    中文</a></li>
                                <li style={{ width: "100%" }} className="border-b py-2"><a className=" dropdown-item" style={{ display: "flex", justifyContent: "space-between" }} href="#ja" onClick={()=>changeLanguage('ja')}>
                                    <span>
                                        <img src="img/ja.jpg"
                                            style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible" }} />
                                    </span>
                                    日本語</a></li>
                                <li style={{ width: "100%" }} className="border-b py-2"><a className=" dropdown-item" style={{ display: "flex", justifyContent: "space-between" }} href="#pt" onClick={()=>changeLanguage('pt')}>
                                    <span>
                                        <img src="img/pt.jpg"
                                            style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible" }} />
                                    </span>
                                    Português</a></li>
                                <li style={{ width: "100%" }} className="border-b py-2"><a className=" dropdown-item" style={{ display: "flex", justifyContent: "space-between" }} href="#it" onClick={()=>changeLanguage('it')}>
                                    <span>
                                        <img src="img/it.jpg"
                                            style={{ height: "25px", width: "25px", borderRadius: "50%", visibility: "visible" }} />
                                    </span>
                                    Italiano</a></li>

                            </div>
                        </div>



                        <a href={`/${AllRoutes.member}`} className="translatable nav-item nav-link nav-contact bg-primary text-white px-5 ms-lg-5"><span className="translatable">Devenir Membre </span><i className="translatable bi bi-arrow-right"></i></a>

                    </div>
                </div>
            </nav>
            <div>
                <Outlet />
            </div>
            <Footer />
        </div>
    )
}

export default Navbar;